import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { publicConfirmVacancySubscription } from "@/lib/api/vacancy-sources.functions";

export const Route = createFileRoute("/careers/subscribe/confirm")({
  validateSearch: (s: Record<string, unknown>) => ({ token: String(s.token ?? "") }),
  head: () => ({
    meta: [
      { title: "Confirm vacancy alerts — Nkadimeng Danny Legal" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ConfirmPage,
});

function ConfirmPage() {
  const { token } = useSearch({ from: "/careers/subscribe/confirm" });
  const fn = useServerFn(publicConfirmVacancySubscription);
  const [state, setState] = useState<"loading" | "ok" | "already" | "invalid">("loading");

  useEffect(() => {
    if (!token) {
      setState("invalid");
      return;
    }
    fn({ data: { token } })
      .then((r: any) => {
        if (!r.ok) setState("invalid");
        else if (r.alreadyConfirmed) setState("already");
        else setState("ok");
      })
      .catch(() => setState("invalid"));
  }, [token]);

  return (
    <div className="container-narrow py-16 text-center">
      {state === "loading" && <p>Confirming…</p>}
      {state === "ok" && (
        <>
          <h1 className="font-display text-2xl text-navy">You're subscribed 🎉</h1>
          <p className="mt-2 text-muted-foreground">
            We'll email you as soon as matching vacancies are posted on employer career pages.
          </p>
        </>
      )}
      {state === "already" && (
        <>
          <h1 className="font-display text-2xl text-navy">Already confirmed</h1>
          <p className="mt-2 text-muted-foreground">Nothing to do — you're already on the list.</p>
        </>
      )}
      {state === "invalid" && (
        <>
          <h1 className="font-display text-2xl text-navy">Link expired</h1>
          <p className="mt-2 text-muted-foreground">
            Please subscribe again from the careers page.
          </p>
        </>
      )}
    </div>
  );
}
